import * as React from "react";
import type { SVGProps } from "react";
const SvgCaretUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M5.034 15.527 12 8.56l6.967 6.966"
    />
  </svg>
);
export default SvgCaretUp;
